import BlazefunLogo from '../assets/BlazefunLogo.svg';

export const Header = () => {
  return (
    <header className='bg-blazefun-header h-20 xs:h-16 flex items-center pl-8'>
      <img src={BlazefunLogo} alt="Blazefun logo" className='w-32 xs:w-40 h-6 xs:h-8'/>  
    </header>
  );
};